import { inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { Observable } from "rxjs";
import { Auth } from "@angular/fire/auth";

export const HomeGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(Auth);

  return new Observable<boolean>((subscriber) => {
    // Wait for Firebase Auth to initialize
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is logged in, redirect to dashboard
        router.navigate(["/dashboard"]);
        subscriber.next(false);
      } else {
        // User is not logged in, redirect to login
        router.navigate(["/login"]);
        subscriber.next(false);
      }
      subscriber.complete();
      unsubscribe();
    });
  });
};
